import { render, staticRenderFns } from "./BdTeam.vue?vue&type=template&id=ef7af6ca&scoped=true&"
import script from "./BdTeam.vue?vue&type=script&lang=js&"
export * from "./BdTeam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef7af6ca",
  null
  
)

export default component.exports